var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPyramidStorygame1 = function SvgIconPyramidStorygame1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.457 12.025H2.543l-.975 1.632a.478.478 0 0 0 .423.718h12.018c.378 0 .614-.4.423-.718l-.975-1.632ZM3.022 11.225l1.167-1.95h7.623l1.166 1.95H3.022ZM10.166 6.525H5.834l-1.167 1.95h6.665l-1.166-1.95Z",
    fill: "#fff",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.423 3.612a.497.497 0 0 0-.846 0L6.313 5.725h3.374L8.423 3.612Z",
    fill: "#9457EB"
  })));
};
export default SvgIconPyramidStorygame1;